
import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { CandidateV3Item } from "@/lib/model/exambuilder/candidate-v3/candidate-v3";
import {
  EnumProcessStatus,
  EnumSubmitStatus
} from "@/lib/model/exambuilder/candidate-v3/candidate-v3-enum";
import EllipShow from "@/components/ellipShow.vue";
import dayjs from "dayjs";
import vuexStore from "@/store/vuex-store";

@Component({
  components: {
    EllipShow
  }
})
export default class CandidateItem extends Vue {
  @Prop() item!: CandidateV3Item;
  @Prop() versionList!: { label: string; value: number }[];
  @Prop({ type: String, default: "all" })
  scene!: "exam" | "all";

  isHover = false;
  V = vuexStore;

  aiRecommendStatus = {
    0: "-",
    10: "不推荐",
    20: "一般",
    30: "推荐",
    40: "非常推荐"
  };

  auditStatus = {
    0: "-",
    1: "通过",
    2: "待定",
    3: "拒绝"
  };

  submitStatus = {
    0: "未登记",
    1: "面试中",
    2: "已交卷",
    3: "已登记",
    4: "已交卷"
  };

  isBottom = false;

  get EnumProcessStatus() {
    return EnumProcessStatus;
  }

  get findVersion() {
    const el = this.versionList.find(
      version => version.value === this.item.examVersionId
    );
    console.log(el);
    return el ? el.label : "";
  }

  formatAtMin(timeStr: string) {
    return dayjs(timeStr).format("YYYY-MM-DD HH:mm");
  }

  scoreAiConvert(
    submitStatus: EnumSubmitStatus,
    scoreAi: number,
    aiProcessStatus: EnumProcessStatus
  ) {
    if (
      [
        EnumSubmitStatus.EnumSubmitStatusNotSignIn,
        EnumSubmitStatus.EnumSubmitStatusSignIn,
        EnumSubmitStatus.EnumSubmitStatusAnswering
      ].includes(submitStatus)
    ) {
      return "-";
    }

    if (
      [
        EnumSubmitStatus.EnumSubmitStatusFinish,
        EnumSubmitStatus.EnumSubmitStatusNoScore
      ].includes(submitStatus)
    ) {
      return aiProcessStatus === EnumProcessStatus.EnumProcessStatusFinish
        ? scoreAi + "分"
        : "正在打分";
    }
  }

  aiCommentConvert(aiComment: string, aiProcessStatus: EnumProcessStatus) {
    if (
      !aiComment ||
      aiProcessStatus !== EnumProcessStatus.EnumProcessStatusFinish
    ) {
      return "-";
    }

    return aiComment;
  }

  getPosition(e: any) {
    const rect = (e.target as HTMLElement).getBoundingClientRect();
    this.isBottom = rect.top <= 258;
  }

  get canToReport() {
    if ([0, 1, 3].includes(this.item.submitStatus)) {
      return false;
    }
    if (
      this.item.aiProcessStatus !== 3 ||
      (this.item.coderLink.coderOutId !== 0 &&
        this.item.coderLink.submitStatus !== 2)
    ) {
      return false;
    }
    return true;
  }

  toReport() {
    if (this.canToReport) {
      this.operate("watchReport");
    }
  }

  @Emit()
  operate(flag: string, e: any) {
    if (e?.disabled) return;

    return {
      flag,
      row: this.item
    };
  }

  @Emit()
  quickSearch(type: string) {
    return type;
  }

  @Emit()
  showError() {
    return this.item;
  }
}
